(function () {
  function initSubcategoryFilterDrag() {
    document.querySelectorAll('.subcategory-filter-bar[data-subcategory-filter]').forEach(function (bar) {
      if (bar.dataset.dragInit) return;
      bar.dataset.dragInit = '1';

      var isDown = false;
      var startX;
      var scrollLeft;
      var hasDragged = false;
      var startPill = null;

      bar.addEventListener('mousedown', function (e) {
        isDown = true;
        hasDragged = false;
        startX = e.pageX;
        scrollLeft = bar.scrollLeft;
        startPill = e.target.closest ? e.target.closest('.subcategory-filter-bar__pill') : null;
        bar.classList.add('is-dragging');
      });

      bar.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        var walk = e.pageX - startX;
        if (Math.abs(walk) > 5) hasDragged = true;
        bar.scrollLeft = scrollLeft - walk;
        startX = e.pageX;
        scrollLeft = bar.scrollLeft;
      });

      bar.addEventListener('mouseup', function () {
        if (hasDragged && startPill) {
          var preventClick = function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            startPill.removeEventListener('click', preventClick, true);
          };
          startPill.addEventListener('click', preventClick, true);
        }
        isDown = false;
        bar.classList.remove('is-dragging');
      });

      bar.addEventListener('mouseleave', function () {
        isDown = false;
        bar.classList.remove('is-dragging');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSubcategoryFilterDrag);
  } else {
    initSubcategoryFilterDrag();
  }
})();
